import type { RequestComponentProps } from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/base'

import BasePendingApproval from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/CustomContent/PendingApprovals/BasePendingApprovals'

const CardApprovals = ({ request, index, compact, removeRequestById }: RequestComponentProps) => {
  return (
    <BasePendingApproval
      request={request}
      index={index}
      compact={compact}
      removeRequestById={removeRequestById}
    />
  )
}

export default CardApprovals
